import { useStateValue } from '../../index';
import { getHotelDetailError, getHotelDetailRequest, getHotelDetailSuccess } from '../actions';

const useHotelDetail = () => {
  const [{ hotel }, dispatch] = useStateValue();

  const request = async (hotelId) => {
    dispatch(getHotelDetailRequest());
    try {
      const url = `${process.env.API_URL}/hotel/${hotelId}/detail`;
      const req = await fetch(url, { credentials: 'include' });
      const res = await req.json();
      dispatch(getHotelDetailSuccess(res));
    } catch (error) {
      dispatch(getHotelDetailError(error));
    }
  };

  return [hotel, request];
};

export default useHotelDetail;
